<!--
  画面名：フローダイアグラム選択画面
  概要：フローダイアグラムを選択する
  備考：フローダイアグラムを選択していないと各作業毎資料一覧ページは表示されない
-->

<!-- HTML -->
<template>
<v-form
  ref="form"
  lazy-validation
  >

<!-- フローダイアグラムのセクション -->
  <section class="sectionFlowDiagram" :class="{'reference':isRefer}">
    <!-- ページ内コンテンツ -->
    <v-flex class="selectBox">
      <!-- 表示する入力項目を選択するセレクトボックス -->
      <v-select
        v-model="selected"
        :items="flowDiagramJsonData"
        :placeholder="$language.MsgSelectedFlowDiagram"
        item-value="id"
        item-text="name"
        clearable
        :disabled="isRefer"
        :rules="[selectRules]"
        @change="changeFnc()"
      ></v-select>
    </v-flex>
    <!-- フローダイアグラムを囲うエリア -->
    <div id="flowBox">
    <!-- フローダイアグラム -->
      <CommonFlowDiagram
        :isPlan="true"
        :isSetting="isSetting"
        v-if="selected > 0"
        :flowDiagramJsonData="flowDiagramJsonData[selected-1].json"
      />
    </div>
  </section>
</v-form>
</template>
<!-- /HTML -->

<script>
// フローダイアグラム表示コンポーネント
import CommonFlowDiagram from '@/components/parts/common/FlowDiagram'

export default {
  props: {
    planId: Number,
    title: String,
    isNew: Boolean,
    isRefer: Boolean,
    isCopy: Boolean,
    flowdiagramId: Number,
    planCreateDate: String,
    isSetting: { type: Boolean, default: false }
  },
  // コンポーネント内の変数を定義
  data () {
    return {
      // リストボックスから選択されたフローダイアグラムを格納
      selected: '',
      // フローダイアグラムを格納
      flowDiagramJsonData: [],
      // DBアクセスのカウント
      accessCount: 0
    }
  },
  // 使用コンポーネント
  components: {
    // フローダイアグラム表示コンポーネント
    CommonFlowDiagram
  },
  // 起動時処理
  created () {
    // ダイアログの情報取得処理
    this.getFlowDiagram()
  },
  // コンポーネント内の処理を定義
  methods: {
    // APIアクセス時の完了処理
    loadComplete () {
      const maxCount = 2
      this.accessCount++
      if (this.accessCount === maxCount) {
        // プログレスバーの非表示
        this.$store.dispatch('setIsLoading', false)
      }
    },
    // フローダイアグラムリストを取得する
    getFlowDiagram () {
      let self = this
      // callBack関数を作成する
      function callbackGet (response) {
        if (response.status === 200) {
          // データベースから取得したフローダイアグラムデータを格納する
          setTemplateFlowDialgram(response.data)
          self.$forceUpdate()
          // 設定済のフローダイアグラムを設定する
          self.setFlowDiagram()
        } else {
          // 失敗
          console.log(response)
        }
        self.loadComplete()
      }
      // エラー時のcallBack関数を作成する
      function callbackError (err) {
        console.log(err)
      }
      let postData = {}
      postData.callback = callbackGet
      postData.errCallback = callbackError
      // フローダイアグラム情報の取得

      this.$store.dispatch('systemConfig/actionSelectFlowDiagramData', postData)

      // DBから取得したフローダイアグラムデータを格納する
      function setTemplateFlowDialgram (data) {
        for (let i = 0; i < data.length; i++) {
          self.flowDiagramJsonData.push({
            id: data[i].id,
            name: data[i].flow_diagram_name,
            json: JSON.parse(data[i].flow_diagram_json)
          })
        }
      }
    },
    // 選択済みのフローダイアグラムをセットする
    setFlowDiagram () {
      if (this.flowdiagramId) {
        this.selected = this.flowdiagramId
      }
    },
    // DBにデータを送る処理
    sendDB (AisTitle, isCopy, oldId) {
      let self = this
      if (!this.$refs.form.validate()) {
        return
      }
      // callback関数を作成する
      function callbackSuccess (response) {
        // プログレスバーの非表示
        self.$store.dispatch('setIsLoading', false)
        self.$emit('sendId', response.data[0].id, false, self.selected)
        callbackSuccessAfter()
      }
      // callback関数を作成する
      function callbackSuccessAfter () {
        // プログレスバーの非表示
        self.$store.dispatch('setIsLoading', false)
        self.$emit('openSaveDialog', null, false, self.selected)
      }

      if (AisTitle) {
        let date = new Date()
        let dateNow = date.getFullYear() + '/' + ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2)

        const sendData = {
          title: this.title,
          flowDiagramId: this.flowDiagramJsonData[this.selected - 1].id,
          flowDiagramName: this.flowDiagramJsonData[this.selected - 1].name,
          flowDiagramJson: JSON.stringify(this.flowDiagramJsonData[this.selected - 1].json),
          status: 10
        }
        if (this.isNew) {
          sendData.createDate = dateNow
          sendData.isCopy = isCopy
          sendData.oldId = oldId
          sendData.callback = callbackSuccess
          if (isCopy) {
            sendData.replaceName = this.$parent.replacePlanDocName
            sendData.addedName = this.$parent.addedPlanDocName
          }
          // 新規追加処理
          this.$store.dispatch('managementFunction/actionInsertPlanFlowDiagram', sendData)
        } else {
          sendData.id = this.planId
          sendData.callback = callbackSuccessAfter
          // 編集処理
          this.$store.dispatch('managementFunction/actionUpdatePlanFlowDiagram', sendData)
        }
      }
    },
    // フローダイアグラム選択のバリデーション
    selectRules () {
      if (this.selected) {
        return true
      } else {
        return this.$language.MsgNecessary
      }
    },
    // フローダイアグラムの選択が変更されたら呼ばれる
    changeFnc () {
      this.$emit('setCompleteFlowdiagramFalse')
    }
  }
}
</script>

<!-- style読み込み -->
<style lang="scss" scoped>
  @import '@/assets/scss/managementFunction/setting.scss';
</style>
